import React, { useRef, useState, useContext } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { CogIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import TextArea from "../atoms/textarea.atom"
import { toast } from "react-toastify"
import { flatten, parseStringTemplate, TemplateVariables, validateYup } from "./template.utils"
import * as yup from "yup"
import { AuthContext } from "../../context/auth.context"
import { Header } from "../common/header"
import Select from "../atoms/select.atom"
import { getCookie } from "../../helper/auth"
// const templateVariablesFlatten = flatten(TemplateVariables);

export const UpdateTemplate = ({ hubId, onUpdateTemplate }) => {
	const { auth } = useContext(AuthContext)
	const selectedData = auth.passData

	const [configs, setConfigs] = React.useState([])
	const [records, setRecords] = React.useState([])
	const [loading, setLoading] = useState(false)

	const templateTextRef = useRef(null)
	const [error, setError] = useState({})
	const [templateVariablesFlat, setTemplateVariablesFlat] = useState([])
	const [templateVariablesFlatFiltered, setTemplateVariablesFlatFiltered] = React.useState([])
	const optionsType = [
		{ value: "contact", label: "Contact" },
		{ value: "deals", label: "Deals" },
		{ value: "companies", label: "Companies" },
		{ value: "tickets", label: "Ticket" }
	]
	const [optionTypeData, setOptionTypeData] = useState({
		statusLabel: "Contact",
		status: "contact"
	})
	const [formObj, setFormData] = useState({
		text: "",
		name: "",
		senderId: "",
		dtlTemplateId: "",
		contentType: "",
		status: ""
	})
	const [selectedConfig, setSelectedConfig] = useState({})
	const [selectedSenderId, setSelectedSenderId] = useState({})
	const [selectedConfigId, setSelectedConfigId] = useState()
	const [searchVariable, setSearchVariable] = useState()

	const setFormObj = (obj) => {
		setFormData({ ...formObj, ...obj })
	}

	const getConfigs = () => {
		setLoading(true)
		;(async () => {
			// getting all senderId records
			const token = getCookie("token")
			const resRecord = await axiosInstance.get(EndpointConfig.hubAppConfigSender, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			const allRecordRes = resRecord.data.data || []
			setRecords(allRecordRes)

			const res = await axiosInstance.get(EndpointConfig.hubAppConfig, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			const allConfigsRes = (res.data.data || []).map((config) => {
				const thoseSenderIds = allRecordRes.filter(
					(senderObj) => config._id === senderObj.smsConfigId
				)
				return {
					...config,
					linkedSenderIds: thoseSenderIds
				}
			})
			setConfigs(allConfigsRes)

			// Default selected config Id
			let selectedConfig = allConfigsRes.find((c) => c.userId === selectedData.userId)
			setSelectedConfigId({
				contentType: selectedConfig.contentType,
				label: selectedConfig.name,
				userId: selectedConfig.userId,
				value: selectedConfig._id
			})

			// Default selected sender Id
			const mainSenderIds = selectedConfig.linkedSenderIds
			let selectedSenderId = mainSenderIds.find((c) => c.senderId === selectedData.senderId)
			setSelectedSenderId({
				label: selectedSenderId.name,
				value: selectedSenderId.senderId,
				senderId: selectedSenderId.senderId
			})
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const getTemplatePropertiesCallBack = React.useCallback((value) => {
		getTemplateProperties(value)
	}, [])

	const getTemplateProperties = (value) => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.VFTemplateProperties, {
				headers: { Authorization: `Bearer ${token}` },
				params: {
					propertyType: value === "" ? optionTypeData.status : value
				}
			})
			const flatArray = []
			setSearchVariable("")
			setTemplateVariablesFlat([])
			res.data.map((item, index) => {
				if (optionTypeData.status === "contact") {
					flatArray.push({
						contact: item.name
					})
				} else if (optionTypeData.status === "deals") {
					flatArray.push({
						deals: item.name
					})
				} else if (optionTypeData.status === "companies") {
					flatArray.push({
						companies: item.name
					})
				} else if (optionTypeData.status === "tickets") {
					flatArray.push({
						tickets: item.name
					})
				}
			})
			const flatData = flatten(flatArray)
			setTemplateVariablesFlat(flatData)
			setTemplateVariablesFlatFiltered(flatData)
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getConfigs()
		getTemplateProperties("Contact")

		setFormData({
			text: selectedData.text,
			name: selectedData.name,
			senderId: selectedData.senderId,
			dtlTemplateId: selectedData.dtlTemplateId,
			contentType: selectedData.contentType,
			module: selectedData.module,
			status: selectedData.status
		})
	}, [])

	const updateTemplate = () => {
		let schema = yup.object().shape({
			name: yup
				.string()
				.trim()
				.required("Required")
				.matches(
					/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
					"Only alphabets are allowed for this field "
				),
			text: yup.string().trim().required("Required"),
			dtlTemplateId: yup.string().trim(),
			contentType: yup.string().trim().required("Required"),
			module: yup.string().trim().required("Required"),
			status: yup.string().trim().required("Required")
		})
		const reqObj = {
			...formObj,
			userId: selectedData.userId,
			senderId: selectedData.senderId
		}
		validateYup(schema, reqObj)
			.then(() => {
				setError({})
				setLoading(true)
				;(async () => {
					const resDelete = await axiosInstance.delete(EndpointConfig.VFSMSTemplates, {
						headers: {
							"hub-id": hubId
						},
						data: {
							templateId: selectedData._id
						}
					})
					const resPost = await axiosInstance.post(
						EndpointConfig.VFSMSTemplates,
						{
							templates: [{ ...reqObj }]
						},
						{ headers: { "hub-id": hubId } }
					)
					toast("Updated Successfully")
					setFormData({
						text: "",
						name: "",
						userId: "",
						senderId: "",
						dtlTemplateId: "",
						contentType: "",
						module: "",
						status: ""
					})
					onUpdateTemplate?.()
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setError)
	}

	const getTemplatePreview = ({ text }) => {
		try {
			return parseStringTemplate(text, templateVariablesFlat)
		} catch (err) {
			console.error(err)
			return formObj.text
		}
	}

	const onClickVariables = ({ key }) => {
		if (templateTextRef?.current) {
			const currPos = templateTextRef.current.selectionStart
			let existingValue = formObj.text || ""
			const newValue =
				existingValue.slice(0, currPos) +
				`{{${optionTypeData.status + "." + templateVariablesFlat[key]} || Default_Value }}` +
				// `{{${key}}}` +
				existingValue.slice(currPos)
			setFormData({ ...formObj, text: newValue })
		}
	}

	function onTypedSearch(event) {
		const value = event.target.value
		setSearchVariable(value)

		const result = Object.keys(templateVariablesFlatFiltered).map(
			(key) => templateVariablesFlatFiltered[key]
		)
		const filteredArray = value ? result.filter((item) => item.includes(value)) : result

		const flatData = flatten(filteredArray)
		setTemplateVariablesFlat(flatData)
	}

	let thatConfig = configs.find((c) => c.userId === selectedData.userId)
	let thatSenderId = (thatConfig?.linkedSenderIds || []).find(
		(c) => c.senderId === selectedData.senderId
	)

	return (
		<>
			<div className="flex flex-col">
				<Header IconName={CogIcon} subText={"Setup"} mainText={"Update New Templates"} />
				<div className="flex flex-row gap-4">
					<div className="flex flex-col w-3/12 p-4 bg-white rounded">
						<Select
							placeholder={"Contact"}
							label="Contact"
							selectedValue={{
								label: optionTypeData.statusLabel,
								value: optionTypeData.status
							}}
							onSelect={({ label, value }) => {
								setOptionTypeData({ statusLabel: label, status: value })
								getTemplatePropertiesCallBack(value)
							}}
							options={optionsType}
						/>
						<Input
							name="name"
							error={error.name}
							onChange={onTypedSearch}
							value={searchVariable}
							label={"Search"}
							placeholder={"Search Variables"}
						/>
						<div className="mt-2 text-xs text-gray-500 uppercase">
							Available Variables
						</div>
						<div className="overflow-y-auto h-[350px] ">
							<>
								&nbsp;
								{loading && templateVariablesFlat ? (
									<div className="w-full p-1 text-sm text-center text-blue-900 pointer-events-none text-bold">
										Loading...
									</div>
								) : (
									Object.keys(templateVariablesFlat).map((key, index) => {
										return (
											<div
												key={key}
												className="flex flex-col py-2 text-xs border-t border-gray-100 border-solid"
												onClick={() => onClickVariables({ key })}
											>
												{/* <span className="flex-1 text-blue-800">
                          {templateVariablesFlat[key]}
                        </span> */}
												<span className="text-gray-800">
													{templateVariablesFlat[key]}
												</span>
											</div>
										)
									})
								)}
							</>
						</div>
					</div>
					<div className="flex flex-col flex-1 p-4 bg-white rounded">
						<Input
							name="name"
							disabled={true}
							error={error.name}
							onChange={(e) => setFormObj({ name: e.target.value })}
							value={formObj.name}
							label={"Template Name"}
							placeholder={"Template name"}
						/>

						<div className="flex flex-row gap-4">
							<div className="flex flex-col flex-1">
								<TextArea
									label={`Template Text`}
									ref={templateTextRef}
									error={error.text}
									onChange={(e) => setFormObj({ text: e.target.value })}
									value={formObj.text}
									placeholder="Template Text"
								/>
							</div>
							<div className="flex flex-col flex-1">
								<label className="mt-2 text-xs text-gray-500 uppercase">
									Preview Text [Sample Data]
								</label>
								{formObj.text ? (
									<p className="text-sm ">
										{/* {getTemplatePreview({ text: formObj.text })} */}
										{formObj.text}
									</p>
								) : (
									"......."
								)}
							</div>
						</div>
						{/* <div className="flex flex-row gap-4"> */}
						{/* <Input name='userId'
                                error={error.userId}
                                onChange={e => setFormObj({ userId: e.target.value })} value={formObj.userId}
                                label={'User ID'} placeholder={'User ID'}
                            /> */}
						{/* <Input name='senderId'
                                error={error.senderId}
                                onChange={e => setFormObj({ senderId: e.target.value })} value={formObj.senderId}
                                label={'Sender Id'} placeholder={'Sender Id'}
                            /> */}
						{/* </div> */}
						<div className="flex flex-col mt-8">
							<Select
								disabled={true}
								placeholder={
									(configs || []).length === 0 ? "No Configs Found" : "Select"
								}
								error={error?.userId}
								label="Choose UserId from SMS Configuration"
								selectedValue={selectedConfigId}
								valueRendered={(selectedValue) => selectedValue.userId}
								onSelect={(data) => {
									setSelectedConfig(data)
									setSelectedSenderId({})
									setFormObj({
										...formObj,
										contentType: data.contentType
									})
								}}
								options={configs.map((ob) => ({
									label: ob.name,
									value: ob._id,
									userId: ob.userId,
									contentType: ob.contentType
								}))}
								optionsRenderer={(row, { isSelected }) => {
									return (
										<>
											{" "}
											<span className="block ml-3 font-normal truncate">
												{row.userId} <br />
												<span className="block text-xs font-normal truncate">
													config: {row.label}
												</span>
											</span>
										</>
									)
								}}
							/>
							{thatConfig && (
								<div className="text-xs text-gray-400">
									from the configuration <b>{thatConfig.name}</b>
								</div>
							)}
						</div>

						<div className="flex flex-col mt-8">
							<Select
								disabled={true}
								placeholder={
									(thatConfig?.linkedSenderIds || []).length === 0
										? "Please choose config first"
										: "Select"
								}
								error={error?.senderId}
								label={`Choose SenderId linked with ${
									thatConfig?.userId || "UserID"
								}`}
								selectedValue={selectedSenderId}
								valueRendered={(selectedValue) => selectedValue.senderId}
								onSelect={setSelectedSenderId}
								options={(thatConfig?.linkedSenderIds || []).map((ob) => ({
									label: ob.name,
									value: ob._id,
									senderId: ob.senderId
								}))}
								optionsRenderer={(row, { isSelected }) => {
									return (
										<>
											{" "}
											<span className="block ml-3 font-normal truncate">
												{row.senderId} <br />
												<span className="block text-xs font-normal truncate">
													record : {row.label}
												</span>
											</span>
										</>
									)
								}}
							/>
							{thatSenderId && (
								<div className="text-xs text-gray-400">
									from the record <b>{thatSenderId.name}</b>
								</div>
							)}
						</div>
						<div className="flex flex-row gap-4 mt-8">
							<Input
								name="dtlTemplateId"
								disabled={false}
								error={error.dtlTemplateId}
								onChange={(e) => setFormObj({ dtlTemplateId: e.target.value })}
								value={formObj.dtlTemplateId}
								label={"DTL Template Id"}
								placeholder={"DTL Template Id"}
							/>

							<Input
								name="contentType"
								disabled={true}
								error={error.contentType}
								onChange={(e) => setFormObj({ contentType: e.target.value })}
								value={formObj.contentType}
								label={"Content Type"}
								placeholder={"Content Type"}
							/>
							{/* 
                            <Input name='status'
                                error={error.status}
                                onChange={e => setFormObj({ status: e.target.value })} value={formObj.status}
                                label={'Status'} placeholder={'Status'}
                            /> */}
							<Select
								placeholder={"Module"}
								error={error.module}
								label="Module"
								selectedValue={{ label: formObj.module, value: formObj.module }}
								// valueRendered={(selectedValue) => selectedValue.userId}
								onSelect={({ value }) => {
									setFormObj({ module: value })
								}}
								options={["Contact", "Deals", "Companies", "Ticket"].map((ob) => ({
									label: ob,
									value: ob
								}))}
							/>
							<Select
								placeholder={"Status"}
								error={error.status}
								label="Status"
								selectedValue={{ label: formObj.status, value: formObj.status }}
								// valueRendered={(selectedValue) => selectedValue.userId}
								onSelect={({ value }) => {
									setFormObj({ status: value })
								}}
								options={["Active", "InActive"].map((ob) => ({
									label: ob,
									value: ob
								}))}
							/>
						</div>
						<div className="flex flex-row gap-6">
							<div className="flex-[3]">&nbsp;</div>
							<div className="flex-1">
								&nbsp;
								{loading ? (
									<Button className="w-full p-1 text-xs text-black bg-red-100 pointer-events-none">
										Loading
									</Button>
								) : (
									<Button className="w-full" onClick={updateTemplate}>
										Update Template
									</Button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
